import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import PageHeader from '../components/PageHeader';
import usePageSearchIndex from '../hooks/usePageSearchIndex';
import './AnnualReport.css';

const AnnualReport = () => {
  const { isMarathi } = useLanguage();

  usePageSearchIndex({
    mr: ['वार्षिक गोषवारा', 'वार्षिक अहवाल', 'रिपोर्ट'],
    en: ['annual report', 'yearly report', 'report']
  });

  const pageHeaderData = {
    title: {
      marathi: 'वार्षिक गोषवारा',
      english: 'Annual Report'
    },
    subtitle: {
      marathi: 'महाराष्ट्र कामगार कल्याण मंडळाचे वार्षिक गोषवारे',
      english: 'Annual Reports of Maharashtra Labour Welfare Board'
    }
  };

  const content = {
    marathi: {
      mainTitle: 'वार्षिक गोषवारा व अधिक माहिती',
      reports: [
        {
          title: 'वार्षिक गोषवारा २०२४-२०२५',
          link: 'https://mlwb.in/react-static-files/pdf/annual-reports/annual_report_2024-25.pdf',
          year: '2024-2025'
        },
        {
          title: 'वार्षिक गोषवारा २०१८-२०१९',
          link: 'https://mlwb.in/react-static-files/pdf/annual-reports/annual_report_2018-19.pdf',
          year: '2018-2019'
        },
        {
          title: 'वार्षिक गोषवारा २०१७-२०१८',
          link: 'https://mlwb.in/react-static-files/pdf/annual-reports/annual_report_2017-18.pdf',
          year: '2017-2018'
        },
        {
          title: 'वार्षिक गोषवारा २०१५-२०१६',
          link: 'https://mlwb.in/react-static-files/pdf/annual-reports/annual_report_2015-16.pdf',
          year: '2015-2016'
        }
      ],
      lastUpdated: 'शेवटचे अपडेट: 16 सप्टेंबर 2025'
    },
    english: {
      mainTitle: 'Annual Reports & More Information',
      reports: [
        {
          title: 'Annual Report 2024-2025',
          link: 'https://mlwb.in/react-static-files/pdf/annual-reports/annual_report_2024-25.pdf',
          year: '2024-2025'
        },
        {
          title: 'Annual Report 2018-2019',
          link: 'https://mlwb.in/react-static-files/pdf/annual-reports/annual_report_2018-19.pdf',
          year: '2018-2019'
        },
        {
          title: 'Annual Report 2017-2018',
          link: 'https://mlwb.in/react-static-files/pdf/annual-reports/annual_report_2017-18.pdf',
          year: '2017-2018'
        },
        {
          title: 'Annual Report 2015-2016',
          link: 'https://mlwb.in/react-static-files/pdf/annual-reports/annual_report_2015-16.pdf',
          year: '2015-2016'
        }
      ],
      lastUpdated: 'Last Updated: September 16, 2025'
    }
  };

  const currentContent = isMarathi() ? content.marathi : content.english;

  return (
    <div className="annual-report-container">
      {/* Page Header */}
      <PageHeader 
        title={pageHeaderData.title}
        subtitle={pageHeaderData.subtitle}
      />

      <div className="annual-report-content" data-read-section="annual-report-content">
        <h2 className="annual-report-main-title">
          {currentContent.mainTitle}
        </h2>
        
        <div className="annual-report-list">
          {currentContent.reports.map((report, index) => (
            <div key={index} className="annual-report-item">
              <a 
                href={report.link}
                className="annual-report-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${report.title} - ${isMarathi() ? 'PDF डाउनलोड करा' : 'Download PDF'}`}
              >
                <span className="annual-report-arrow">⇨</span>
                <span className="annual-report-title">{report.title}</span>
                <span className="annual-report-icon">
                  <svg 
                    width="16" 
                    height="16" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                  >
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14,2 14,8 20,8"/>
                    <line x1="16" y1="13" x2="8" y2="13"/>
                    <line x1="16" y1="17" x2="8" y2="17"/>
                    <polyline points="10,9 9,9 8,9"/>
                  </svg>
                </span>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AnnualReport;
